module.exports = __webpack_public_path__ + "static/media/icon-skin-gray.70cd69d3.svg";